import {
  DIRECT_TO_HOME,
  FIELD_SALES,
  FUSION_CLOSER,
  FUSION_SETTER,
  INSIDE_SALES,
  UserProfile,
  getSplatUserType,
} from '@sunrun/sales-experience-shared';

const normalizePartnerName = (userProfile: UserProfile | undefined): string =>
  (userProfile?.partnerName ?? '').trim();

/** Internal (Field / AIR) — partnerName `Sunrun` */
const isFieldOrAIRHelper = (userProfile: UserProfile): boolean => {
  return normalizePartnerName(userProfile) === 'Sunrun';
};

/** Community (Street / Fusion) — partnerName `Direct to Home` or `Fusion` */
const isStreetOrFusionHelper = (userProfile: UserProfile): boolean => {
  const name = normalizePartnerName(userProfile);
  return name === 'Direct to Home' || name === 'Fusion';
};

/** Affiliate — non-empty partnerName that is not Sunrun, Fusion, or Direct to Home */
const isAffiliateHelper = (userProfile: UserProfile): boolean => {
  return (
    !!userProfile?.partnerName &&
    !isFieldOrAIRHelper(userProfile) &&
    !isStreetOrFusionHelper(userProfile)
  );
};

type NewDashboardOrgType = 'BLOCK' | 'STREET' | 'CHAIN' | 'AIR' | 'UNKNOWN';

const getNewDashboardOrgType = (
  userProfile: UserProfile | undefined,
): NewDashboardOrgType => {
  if (!userProfile) {
    return 'UNKNOWN';
  }
  const splatUserType = getSplatUserType(userProfile);

  switch (splatUserType) {
    case FUSION_CLOSER:
      return 'BLOCK';
    case FUSION_SETTER:
      return 'BLOCK';
    case DIRECT_TO_HOME:
      return 'STREET';
    case FIELD_SALES:
      return 'CHAIN';
    case INSIDE_SALES:
      return 'AIR';
    default:
      return 'UNKNOWN';
  }
};

export type { NewDashboardOrgType };
export {
  getNewDashboardOrgType,
  isStreetOrFusionHelper,
  isFieldOrAIRHelper,
  isAffiliateHelper,
};
